import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { cardsService, UnlockCardRequest } from '@aslanpay/portal-common-lib';

const useUnlockCard = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, UnlockCardRequest>) => {
  return useMutation<unknown, Error, UnlockCardRequest>(
    ({ id }: UnlockCardRequest) =>
      cardsService.unlockCard({
        id,
      }),
    { onSuccess, onError }
  );
};

export default useUnlockCard;
